import { render, staticRenderFns } from "./UserMessageDashboardTile.vue?vue&type=template&id=a2fddae0&scoped=true&"
import script from "./UserMessageDashboardTile.vue?vue&type=script&lang=js&"
export * from "./UserMessageDashboardTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fddae0",
  null
  
)

export default component.exports